import { useRef, useEffect, useState } from 'react';
import Logo from '../../assets/images/supunnisalalogo.png';
import { useInView } from 'react-intersection-observer'
import './Header.scss'

function Header({headerIsVisible}){
    
    const [myElementIsVisible, setMyElementIsVisible] = useState(headerIsVisible);

    useEffect(() => {
        setMyElementIsVisible(headerIsVisible);
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
        })
    }, [headerIsVisible])

    return(
        <nav  className={`fixed bg-white top-0 left-0 right-0 w-full z-50 header transition-all duration-500 ease-in hidden md:block ${myElementIsVisible ? 'opacity-100' : 'opacity-0' }`} >
            <div className='flex items-center justify-between p-2'>
                <div>
                    <img src={Logo} className='w-16 ml-5 p-1' alt='supunnisalalg'></img>
                </div>
                <div>
                    <ul className='flex flex-row justify-end font-medium font-mono text-gray-500 ' >
                        <li className='mr-5 hover:text-amber-700'><a href='#about'  >About</a></li>
                        <li className='mr-5 hover:text-amber-700'><a href='#lifeExperience'>Life Experience</a></li>
                        <li className='mr-5 hover:text-amber-700'><a href='#portfolio'>Portfolio</a></li>
                        <li className='mr-5 hover:text-amber-700'><a href='#contact'>Contact</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Header;